import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { CheckBoxField } from '../../../ui/FormElement';

function IsPayPerUsed(props) {
  const { isDisabled, ...rest } = props;

  const {
    values: { is_pay_per_used },
    setFieldValue,
  } = useFormikContext();

  return (

    <CheckBoxField
      disabled={isDisabled}
      name="is_pay_per_used"
      inline
    />

  );
}

export default IsPayPerUsed;
